import {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'

import getGlobal from '../../getGlobal'
import { EMPTY_OBJECT } from '../constants'
import { rafThrottle } from '../timing'

const global = getGlobal()

export const useResizeObserver = () => {
  const ref = useRef(null)
  const [dimensions, setDimensions] = useState({ width: null, height: null })
  useEffect(() => {
    const { current: watchNode } = ref
    let observer
    let interval
    let intervalCount = 0
    let timeout
    const resizeHandler = () => {
      const { width, height } = ref.current?.getBoundingClientRect() ?? EMPTY_OBJECT
      if (timeout) {
        clearTimeout(timeout)
      }
      setDimensions(old => {
        if (width !== old.width || height !== old.height) {
          return { width, height }
        }
        return old
      })
      timeout = setTimeout(resizeHandler, 166)
    }
    const initResizeObserver = () => {
      if (!watchNode || watchNode instanceof global.HTMLElement === false) {
        return
      }

      observer = new ResizeObserver(rafThrottle(resizeHandler))
      observer.observe(watchNode)
    }
    if (typeof ResizeObserver === 'undefined' && typeof setInterval !== 'undefined') {
      let abortInterval = false
      interval = setInterval(() => {
        intervalCount += 1
        if (typeof ResizeObserver !== 'undefined') {
          initResizeObserver()
          abortInterval = true
        }
        if (intervalCount >= 100) {
          abortInterval = true
        }
        if (abortInterval) {
          clearInterval(interval)
          interval = null
        }
      }, 66)
    } else {
      initResizeObserver()
    }

    return () => {
      if (observer) observer.unobserve(watchNode)
      if (interval) clearInterval(interval)
    }
  }, [ref.current])

  return useMemo(() => ({
    ref,
    ...dimensions,
  }), [dimensions])
}
